/**
 * docs.swaps.app in the v4 "Paper & Ink" brand, with the files swaps.app uses (G 2026-10-06: icon 4, theme Paper,
 * preview 1). The icons and the header lockup are copies of the brand kit (public/brand/v4/) in apps/docs/public,
 * because this site is served from its own public/ (dist/_docs), where /brand/v4/ does not exist.
 * `pnpm run brand:kit:v4` writes them (scripts/brand/export-v4-brand-kit.mjs, SERVED_COPIES), and its test holds every
 * value below to the kit, the --paper token and the site's link preview.
 *
 * Paths are site-relative: Zudoku puts the basePath in front of `site.logo` and `metadata.favicon` itself, and the
 * head plugin in zudoku.config.tsx does it for the rest.
 */
export const DOCS_BRAND = {
  /** The header logo: the lockup (wordmark and .app badge, with its clear space), Ink in the light theme, Paper in the dark. */
  logo: { light: '/swaps-lockup-ink.svg', dark: '/swaps-lockup-paper.svg' },
  favicon: '/favicon.ico',
  pngIcons: [
    { sizes: '32x32', href: '/favicon-32x32.png' },
    { sizes: '16x16', href: '/favicon-16x16.png' },
  ],
  appleTouchIcon: '/apple-touch-icon.png',
  /** Paper (`--paper`), the theme colour of swaps.app. */
  themeColor: '#F7F6F2',
  /** The link preview of swaps.app (config/social-preview.mjs), with its alt (config/brand-positioning-line.json). */
  ogImage: {
    url: 'https://www.swaps.app/brand/v4/swaps-og-default.png',
    type: 'image/png',
    width: 1200,
    height: 630,
    alt: 'Payments, payroll and crypto — the whole route, before money moves.',
  },
} as const;
